<template>
  <TarjetaDatos titulo="Vehículo">
    <Campo2L :valor="poliza.vehiculo" />
    <Campo2L :valor="poliza.matricula" etiqueta="Matrícula" />
    <Campo2L :valor="poliza.numBastidor" etiqueta="Bastidor" />
    <Campo2L :valor="poliza.clase" etiqueta="Clase" />
    <Campo2L :valor="poliza.uso" etiqueta="Uso" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
